/**
 * Maps the onboarding `?step=N` query parameter to the stepper index the
 * page should display, or `null` when the param shouldn't be honoured.
 *
 * Used by the page's deep-link effect so the GBP and POS health-banner CTAs
 * can drop a returning retailer straight into the broken step. Extracted as
 * a pure helper because the in-page effect threads several refs / state
 * setters that are awkward to test together — the resolution logic itself
 * stands alone.
 *
 *   step=2 (GBP)  →  index 1, requires businessDetailsCompleted
 *   step=3 (POS)  →  index 2, requires businessDetailsCompleted + gbpCompleted
 *   anything else →  null  (helper does NOT honour step=1 — the natural
 *                           progression already handles a fresh signup)
 *
 * @param {string|number|null} stepParam — the raw value of `?step=`
 * @param {{ businessDetailsCompleted?: boolean, gbpCompleted?: boolean }} progress
 * @returns {number|null} zero-indexed step to display, or null
 */
export function resolveDeepLinkStep(stepParam, { businessDetailsCompleted = false, gbpCompleted = false } = {}) {
	if (stepParam !== '2' && stepParam !== '3') return null;
	const targetIndex = Number(stepParam) - 1;
	if (targetIndex === 1 && businessDetailsCompleted) return 1;
	if (targetIndex === 2 && businessDetailsCompleted && gbpCompleted) return 2;
	return null;
}
